/* Optional wishlist text sharing. Reads the displayed list; no API or account data. */
(() => {
  'use strict';
  function init() {
    const dialog = document.getElementById('bsw-dialog');
    const items = dialog?.querySelector('[data-bsw-items]');
    if (!items || dialog.querySelector('.bsw-share-tools')) return;
    const languages = {
      en: ['Copy list','Share','Copied','Select and copy the text below.','Could not share. Please use Copy list.','Wishlist text','Unavailable'],
      ru: ['Скопировать список','Поделиться','Скопировано','Выделите и скопируйте текст ниже.','Не удалось поделиться. Скопируйте список.','Текст списка желаний','Недоступно'],
      de: ['Liste kopieren','Teilen','Kopiert','Markieren und kopieren Sie den Text unten.','Teilen nicht möglich. Bitte kopieren Sie die Liste.','Wunschliste als Text','Nicht verfügbar'],
      fr: ['Copier la liste','Partager','Copié','Sélectionnez et copiez le texte ci-dessous.','Partage impossible. Veuillez copier la liste.','Liste de souhaits en texte','Indisponible'],
      it: ['Copia lista','Condividi','Copiato','Seleziona e copia il testo qui sotto.','Impossibile condividere. Copia la lista.','Lista dei desideri in testo','Non disponibile'],
      es: ['Copiar lista','Compartir','Copiado','Selecciona y copia el texto de abajo.','No se pudo compartir. Copia la lista.','Lista de deseos en texto','No disponible'],
      ja: ['リストをコピー','共有','コピーしました','以下のテキストを選択してコピーしてください。','共有できませんでした。リストをコピーしてください。','ウィッシュリストのテキスト','現在利用できません']
    };
    const text = languages[(document.documentElement.lang || 'en').toLowerCase().split('-')[0]] || languages.en;
    const make = (tag, cls, value) => { const el = document.createElement(tag); el.className = cls; if (value) el.textContent = value; return el; };
    const tools = make('div','bsw-share-tools');
    const actions = make('div','bsw-share-actions');
    const copy = make('button','bsw-share-button',text[0]); copy.type = 'button';
    const share = make('button','bsw-share-button',text[1]); share.type = 'button';
    function icon(kind) {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns,'svg');
      for (const [key,value] of Object.entries({class:'bsw-share-icon',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.5','aria-hidden':'true',focusable:'false'})) svg.setAttribute(key,value);
      // Share uses an open square with an upward arrow.
      const shapes = kind === 'share'
        ? [['path',{d:'M8 10H5v11h14V10h-3M12 15V2M8 6l4-4 4 4','stroke-linecap':'round','stroke-linejoin':'round'}]]
        : [['rect',{x:8,y:8,width:12,height:13,rx:1}],['path',{d:'M5 16H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1'}]];
      for (const [tag,attributes] of shapes) {
        const shape = document.createElementNS(ns,tag);
        for (const [key,value] of Object.entries(attributes)) shape.setAttribute(key,String(value));
        svg.append(shape);
      }
      return svg;
    }
    copy.prepend(icon('copy')); share.prepend(icon('share'));
    const status = make('p','bsw-share-status'); status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    const manual = make('textarea','bsw-share-manual'); manual.readOnly = true; manual.hidden = true; manual.setAttribute('aria-label',text[5]);
    actions.append(copy,share); tools.append(actions,status,manual);
    const header = dialog.querySelector('.bscc-header');
    if (header) header.after(tools); else items.before(tools);
    let pending = false, generation = 0;
    function snapshot() {
      return [...items.querySelectorAll('.bsw-item')].map(row => {
        const title = row.querySelector('h3')?.textContent?.replace(/\s+/g,' ').trim();
        if (!title) return null;
        const link = row.querySelector('a[data-bsw-visit]');
        let url = '';
        try {
          const candidate = new URL(link?.getAttribute('href') || '',location.origin);
          if (candidate.origin === location.origin && /^\/(?:[a-zA-Z0-9-]+\/)?products\/[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(candidate.pathname)) url = candidate.origin + candidate.pathname;
        } catch (_) { /* A missing or unsafe link is never exported. */ }
        return {title,url};
      }).filter(Boolean);
    }
    function payload() {
      const rows = snapshot();
      if (!rows.length) return null;
      return {text:'My Bright & Shiny wishlist ♡\n\n'+rows.map((row,i)=>`${i+1}. ${row.title}\n${row.url || text[6]}`).join('\n\n')};
    }
    function update() {
      const data = payload();
      let supported = typeof navigator.share === 'function';
      try { if (supported && data && typeof navigator.canShare === 'function') supported = navigator.canShare(data); } catch (_) { supported = false; }
      share.hidden = !supported;
      copy.disabled = pending || !data;
      share.disabled = pending || !data;
    }
    copy.addEventListener('click',async () => {
      const data = payload(); if (!data || pending) return;
      const run = generation; pending = true; status.textContent = ''; manual.hidden = true; update();
      try {
        if (!navigator.clipboard?.writeText) throw new Error('clipboard_unavailable');
        await navigator.clipboard.writeText(data.text);
        if (run === generation) status.textContent = text[2];
      } catch (_) {
        if (run === generation && dialog.open) {
          manual.value = data.text; manual.hidden = false; status.textContent = text[3]; manual.focus(); manual.select();
        }
      } finally { pending = false; update(); }
    });
    share.addEventListener('click',async () => {
      const data = payload(); if (!data || pending) return;
      const run = generation; pending = true; status.textContent = ''; manual.hidden = true; update();
      try {
        // Call directly from the click, retaining the browser's user activation.
        await navigator.share(data);
      } catch (error) {
        if (run === generation && error?.name !== 'AbortError') status.textContent = text[4];
      } finally { pending = false; update(); }
    });
    new MutationObserver(() => { generation++; manual.value = ''; manual.hidden = true; status.textContent = ''; update(); }).observe(items,{childList:true,subtree:true,characterData:true});
    dialog.addEventListener('close',() => { generation++; manual.value = ''; manual.hidden = true; status.textContent = ''; });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
